/**
 * JavaScript Utility
 * Author: 서명환 <mhseo@ulalalab.com>
 */
var util = util || {};

(function() {
  var global = this;
  var objectPrototype = Object.prototype;
  var toString = objectPrototype.toString;
  var enumerables = [/*'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',*/ 'valueOf', 'toLocaleString', 'toString', 'constructor'];
  var emptyFn = function() {};
  var identityFn = function(o) {
    return o;
  };
  var iterableRe = /\[object\s*(?:Array|Arguments|\w*Collection|\w*List|HTML\s+document\.all\s+class)\]/;
  var MSDateRe = /^\\?\/Date\(([-+])?(\d+)(?:[+-]\d{4})?\)\\?\/$/;

  util.global = global;

  util.now = Date.now || (Date.now = function() {
    return +new Date();
  });

  // util.ticks = global.performance && global.performance.now ? function() {
  //     return performance.now();
  // } : util.now;

  emptyFn.$nullFn = identityFn.$nullFn = emptyFn.$emptyFn = identityFn.$identityFn = true;

  emptyFn.$noClearOnDestroy = identityFn.$noClearOnDestroy = true;

  for(var i in {toString: 1}) {
    enumerables = null;
  }

  util.enumerables = enumerables;

  util.dateDiff = function(_date1, _date2){
    var diffDate_1 = _date1 instanceof Date ? _date1 : new Date(_date1);
    var diffDate_2 = _date2 instanceof Date ? _date2 : new Date(_date2);

    diffDate_1 = new Date(diffDate_1.getFullYear(), diffDate_1.getMonth()+1, diffDate_1.getDate());
    diffDate_2 = new Date(diffDate_2.getFullYear(), diffDate_2.getMonth()+1, diffDate_2.getDate());

    var diff = Math.abs(diffDate_2.getTime() - diffDate_1.getTime());
    diff = Math.ceil(diff / (1000 * 3600 * 24));

    return diff;
  };

  util.apply = function(object, config, defaults) {
    if(object) {
      if(defaults) {
        util.apply(object, defaults);
      }

      if(config && typeof config === 'object') {
        for(var i in config) {
          object[i] = config[i];
        }

        if(enumerables) {
          for(var j = enumerables.length; j--;) {
            var k = enumerables[j];
            if(config.hasOwnProperty(k)) {
              object[k] = config[k];
            }
          }
        }
      }
    }

    return object;
  };

  util.apply(util, {
    emptyFn: emptyFn,
    identityFn: identityFn,
    validIdRe: /^[a-z_][a-z0-9\-_]*$/i,
    makeIdSelector: function(id) {
      if(!util.validIdRe.test(id)) {
        return id;
      }
      return '#' + id;
    },
    returnTrue: function() {
      return true;
    },
    emptyArray: Object.freeze ? Object.freeze([]) : [],
    applyIf: function(object, config) {
      if(object && config && typeof config === 'object') {
        for(var property in config) {
          if(object[property] === undefined) {
            object[property] = config[property];
          }
        }
      }

      return object;
    },
    isEmpty: function(value, allowEmptyString) {
      return value == null || (!allowEmptyString ? value === '' : false) || (util.isArray(value) && value.length === 0) || (util.isObject(value) && util.Object.isEmpty(value));
    },
    isArray: 'isArray' in Array ? Array.isArray : function(value) {
      return toString.call(value) === '[object Array]';
    },

    isObject: toString.call(null) === '[object Object]' ? function(value) {
      return value != null && toString.call(value) === '[object Object]' && value.ownerDocument === undefined;
    } : function(value) {
      return toString.call(value) === '[object Object]';
    },

    isFunction: typeof document !== 'undefined' && typeof document.getElementsByTagName('body') === 'function' ? function(value) {
      return !!value && toString.call(value) === '[object Function]';
    } : function(value) {
      return !!value && typeof value === 'function';
    },
    isNumber: function(value) {
      return typeof value === 'number' && isFinite(value);
    },
    isNumeric: function(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    isString: function(value) {
      return typeof value === 'string';
    },
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },
  });

  util.returnTrue.$nullFn = true;

  var TemplateClass = function() {};
  var queryRe = /^\?/;
  var keyRe = /(\[):?([^\]]*)\]/g;
  var nameRe = /^([^\[]+)/;
  var plusRe = /\+/g;
  var utilObject = util.Object = {
    each: function(object, fn, scope) {
      var enumerables = util.enumerables;
      var property;

      if(object) {
        scope = scope || object;

        for(property in object) {
          if(object.hasOwnProperty(property)) {
            if(fn.call(scope, property, object[property], object) === false) {
              return;
            }
          }
        }

        if(enumerables) {
          for(var i = enumerables.length; i--;) {
            if(object.hasOwnProperty(property = enumerables[i])) {
              if(fn.call(scope, property, object[property], object) === false) {
                return;
              }
            }
          }
        }
      }
    },

    eachValue: function(object, fn, scope) {
      var enumerables = util.enumerables;
      var property;

      scope = scope || object;

      for(property in object) {
        if(object.hasOwnProperty(property)) {
          if(fn.call(scope, object[property]) === false) {
            return;
          }
        }
      }

      if(enumerables) {
        for(var i = enumerables.length; i--;) {
          if(object.hasOwnProperty(property = enumerables[i])) {
            if(fn.call(scope, object[property]) === false) {
              return;
            }
          }
        }
      }
    },

    getAllKeys: function(object) {
      var keys = [];

      for(var property in object) {
        keys.push(property);
      }

      return keys;
    },
    getKey: function(object, value) {
      for(var property in object) {
        if(object.hasOwnProperty(property) && object[property] === value) {
          return property;
        }
      }

      return null;
    },
    isEmpty: function(object) {
      for(var key in object) {
        if(object.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    },
  };

  util.merge = util.Object.merge;
  util.mergeIf = util.Object.mergeIf;
}());


util.Array = function() {
  var arrayPrototype = Array.prototype;
  var slice = arrayPrototype.slice;
  var supportsSplice = function() {
    var array = [];
    var j = 20;

    if(!array.splice) {
      return false;
    }

    while(j--) {
      array.push('A');
    }

    array.splice(15, 0, 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F', 'F');

    var lengthBefore = array.length;
    array.splice(13, 0, 'XXX');

    if(lengthBefore + 1 !== array.length) {
      return false;
    }

    return true;
  }();
  var supportsIndexOf = 'indexOf' in arrayPrototype;
  var supportsSliceOnNodeList = true;

  function stableSort(array, userComparator) {
    var len = array.length;
    var indices = new Array(len);
    var i;

    for(i = 0; i < len; i++) {
      indices[i] = i;
    }

    indices.sort(function(index1, index2) {
      return userComparator(array[index1], array[index2]) || index1 - index2;
    });

    for(i = 0; i < len; i++) {
      indices[i] = array[indices[i]];
    }

    for(i = 0; i < len; i++) {
      array[i] = indices[i];
    }

    return array;
  }

  try {
    if(typeof document !== 'undefined') {
      slice.call(document.getElementsByTagName('body'));
    }
  }
  catch(e) {
    supportsSliceOnNodeList = false;
  }

  var fixArrayIndex = function(array, index) {
    return index < 0 ? Math.max(0, array.length + index) : Math.min(array.length, index);
  };

  var replaceSim = function(array, index, removeCount, insert) {
    var add = insert ? insert.length : 0;
    var length = array.length;
    var pos = fixArrayIndex(array, index);

    if(pos === length && add) {
      array.push.apply(array, insert);
    }
    else {
      var remove = Math.min(removeCount, length - pos);
      var tailOldPos = pos + remove;
      var tailNewPos = tailOldPos + add - remove;
      var tailCount = length - tailOldPos;
      var lengthAfterRemove = length - remove;
      var i;

      if(tailNewPos < tailOldPos) {
        for(i = 0; i < tailCount; ++i) {
          array[tailNewPos + i] = array[tailOldPos + i];
        }
      }
      else if(tailNewPos > tailOldPos) {
        for(i = tailCount; i--;) {
          array[tailNewPos + i] = array[tailOldPos + i];
        }
      }

      if(add && pos === lengthAfterRemove) {
        array.length = lengthAfterRemove;
        array.push.apply(array, insert);
      }
      else {
        array.length = lengthAfterRemove + add;
        for(i = 0; i < add; ++i) {
          array[pos + i] = insert[i];
        }
      }
    }

    return array;
  };

  var replaceNative = function(array, index, removeCount, insert) {
    if(insert && insert.length) {
      if(index === 0 && !removeCount) {
        array.unshift.apply(array, insert);
      }
      else if(index < array.length) {
        array.splice.apply(array, [index, removeCount].concat(insert));
      }
      else {
        array.push.apply(array, insert);
      }
    }
    else {
      array.splice(index, removeCount);
    }
    return array;
  };

  var eraseSim = function(array, index, removeCount) {
    return replaceSim(array, index, removeCount);
  };

  var eraseNative = function(array, index, removeCount) {
    array.splice(index, removeCount);
    return array;
  };

  var spliceSim = function(array, index, removeCount) {
    var len = arguments.length;
    var pos = fixArrayIndex(array, index);

    if(len < 3) {
      removeCount = array.length - pos;
    }

    var removed = array.slice(index, fixArrayIndex(array, pos + removeCount));

    if(len < 4) {
      replaceSim(array, pos, removeCount);
    }
    else {
      replaceSim(array, pos, removeCount, slice.call(arguments, 3));
    }

    return removed;
  };

  var spliceNative = function(array) {
    return array.splice.apply(array, slice.call(arguments, 1));
  };

  var erase = supportsSplice ? eraseNative : eraseSim;
  var replace = supportsSplice ? replaceNative : replaceSim;
  var splice = supportsSplice ? spliceNative : spliceSim;

  var utilArray = {
    binarySearch: function(array, item, begin, end, compareFn) {
      var length = array.length;

      if(begin instanceof Function) {
        compareFn = begin;
        begin = 0;
        end = length;
      }
      else if(end instanceof Function) {
        compareFn = end;
        end = length;
      }
      else {
        if(begin === undefined) {
          begin = 0;
        }
        if(end === undefined) {
          end = length;
        }
        compareFn = compareFn || utilArray.lexicalCompare;
      }

      --end;

      while(begin <= end) {
        var middle = begin + end >> 1;
        var comparison = compareFn(item, array[middle]);
        if(comparison >= 0) {
          begin = middle + 1;
        }
        else if(comparison < 0) {
          end = middle - 1;
        }
      }

      return begin;
    },
    defaultCompare: function(lhs, rhs) {
      return lhs < rhs ? -1 : (lhs > rhs ? 1 : 0);
    },
    lexicalCompare: function(lhs, rhs) {
      lhs = String(lhs);
      rhs = String(rhs);

      return lhs < rhs ? -1 : (lhs > rhs ? 1 : 0);
    },
    each: function(array, fn, scope, reverse) {
      array = utilArray.from(array);

      var i;
      var ln = array.length;

      if(reverse !== true) {
        for(i = 0; i < ln; i++) {
          if(fn.call(scope || array[i], array[i], i, array) === false) {
            return i;
          }
        }
      }
      else {
        for(i = ln - 1; i > -1; i--) {
          if(fn.call(scope || array[i], array[i], i, array) === false) {
            return i;
          }
        }
      }

      return true;
    },
    findInsertionIndex: function(item, items, comparatorFn, index) {
      var len = items.length;

      comparatorFn = comparatorFn || utilArray.lexicalCompare;

      if(index < len) {
        var beforeCheck = index > 0 ? comparatorFn(items[index - 1], item) : 0;
        var afterCheck = index < len - 1 ? comparatorFn(items, items[index]) : 0;
        if(beforeCheck < 1 && afterCheck < 1) {
          return index;
        }
      }

      return utilArray.binarySearch(items, item, comparatorFn);
    },
    forEach: 'forEach' in arrayPrototype ? function(array, fn, scope) {
      array.forEach(fn, scope);
    } : function(array, fn, scope) {
      for(var i = 0, ln = array.length; i < ln; i++) {
        fn.call(scope, array[i], i, array);
      }
    },
    indexOf: supportsIndexOf ? function(array, item, from) {
      return array ? arrayPrototype.indexOf.call(array, item, from) : -1;
    } : function(array, item, from) {
      var length = array ? array.length : 0;

      for(var i = from < 0 ? Math.max(0, length + from) : from || 0; i < length; i++) {
        if(array[i] === item) {
          return i;
        }
      }

      return -1;
    },
    contains: supportsIndexOf ? function(array, item) {
      return arrayPrototype.indexOf.call(array, item) !== -1;
    } : function(array, item) {
      for(var i = 0, ln = array.length; i < ln; i++) {
        if(array[i] === item) {
          return true;
        }
      }

      return false;
    },
    toArray: function(iterable, start, end) {
      if(!iterable || !iterable.length) {
        return [];
      }

      if(typeof iterable === 'string') {
        iterable = iterable.split('');
      }

      if(supportsSliceOnNodeList) {
        return slice.call(iterable, start || 0, end || iterable.length);
      }

      var array = [];

      start = start || 0;
      end = end ? (end < 0 ? iterable.length + end : end) : iterable.length;

      for(var i = start; i < end; i++) {
        array.push(iterable[i]);
      }

      return array;
    },
    pluck: function(array, propertyName) {
      var ret = [];

      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        ret.push(item[propertyName]);
      }

      return ret;
    },
    map: 'map' in arrayPrototype ? function(array, fn, scope) {
      return array.map(fn, scope);
    } : function(array, fn, scope) {
      var len = array.length;
      var results = new Array(len);

      for(var i = 0; i < len; i++) {
        results[i] = fn.call(scope, array[i], i, array);
      }

      return results;
    },
    every: 'every' in arrayPrototype ? function(array, fn, scope) {
      return array.every(fn, scope);
    } : function(array, fn, scope) {
      for(var i = 0, ln = array.length; i < ln; ++i) {
        if(!fn.call(scope, array[i], i, array)) {
          return false;
        }
      }

      return true;
    },
    some: 'some' in arrayPrototype ? function(array, fn, scope) {
      return array.some(fn, scope);
    } : function(array, fn, scope) {
      for(var i = 0, ln = array.length; i < ln; ++i) {
        if(fn.call(scope, array[i], i, array)) {
          return true;
        }
      }

      return false;
    },
    equals: function(array1, array2) {
      var len1 = array1.length;
      var len2 = array2.length;

      if(len1 !== len2) {
        return false;
      }

      for(var i = 0; i < len1; ++i) {
        if(array1[i] !== array2[i]) {
          return false;
        }
      }

      return true;
    },
    clean: function(array) {
      var results = [];

      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        if(!util.isEmpty(item)) {
          results.push(item);
        }
      }

      return results;
    },
    unique: function(array) {
      var clone = [];

      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        if(utilArray.indexOf(clone, item) === -1) {
          clone.push(item);
        }
      }

      return clone;
    },
    filter: 'filter' in arrayPrototype ? function(array, fn, scope) {
      return array.filter(fn, scope);
    } : function(array, fn, scope) {
      var results = [];

      for(var i = 0, ln = array.length; i < ln; i++) {
        if(fn.call(scope, array[i], i, array)) {
          results.push(array[i]);
        }
      }

      return results;
    },
    findBy: function(array, fn, scope) {
      for(var i = 0, len = array.length; i < len; i++) {
        if(fn.call(scope || array, array[i], i)) {
          return array[i];
        }
      }
      return null;
    },
    from: function(value, newReference) {
      if(value === undefined || value === null) {
        return [];
      }

      if(util.isArray(value)) {
        return newReference ? slice.call(value) : value;
      }

      var type = typeof value;
      if(value && value.length !== undefined && type !== 'string' && (type !== 'function' || !value.apply)) {
        return utilArray.toArray(value);
      }

      return [value];
    },
    remove: function(array, item) {
      var index = utilArray.indexOf(array, item);

      if(index !== -1) {
        erase(array, index, 1);
      }

      return array;
    },
    removeAt: function(array, index, count) {
      var len = array.length;
      if(index >= 0 && index < len) {
        count = count || 1;
        count = Math.min(count, len - index);
        erase(array, index, count);
      }
      return array;
    },
    include: function(array, item) {
      if(!utilArray.contains(array, item)) {
        array.push(item);
      }
    },
    clone: function(array) {
      return slice.call(array);
    },

    merge: function() {
      var args = slice.call(arguments);
      var array = [];

      for(var i = 0, ln = args.length; i < ln; i++) {
        array = array.concat(args[i]);
      }

      return utilArray.unique(array);
    },
    intersect: function() {
      var intersection = [];
      var arrays = slice.call(arguments);
      var minArray;
      var minArrayIndex;
      var i;

      if(!arrays.length) {
        return intersection;
      }

      var arraysLength = arrays.length;
      for(i = minArrayIndex = 0; i < arraysLength; i++) {
        var minArrayCandidate = arrays[i];
        if(!minArray || minArrayCandidate.length < minArray.length) {
          minArray = minArrayCandidate;
          minArrayIndex = i;
        }
      }

      minArray = utilArray.unique(minArray);
      erase(arrays, minArrayIndex, 1);

      var minArrayLength = minArray.length;
      arraysLength = arrays.length;
      for(i = 0; i < minArrayLength; i++) {
        var element = minArray[i];
        var elementCount = 0;

        for(var j = 0; j < arraysLength; j++) {
          var array = arrays[j];
          for(var k = 0, arrayLength = array.length; k < arrayLength; k++) {
            var elementCandidate = array[k];
            if(element === elementCandidate) {
              elementCount++;
              break;
            }
          }
        }

        if(elementCount === arraysLength) {
          intersection.push(element);
        }
      }

      return intersection;
    },
    difference: function(arrayA, arrayB) {
      var clone = slice.call(arrayA);
      var ln = clone.length;

      for(var i = 0, lnB = arrayB.length; i < lnB; i++) {
        for(var j = 0; j < ln; j++) {
          if(clone[j] === arrayB[i]) {
            erase(clone,j, 1);
            j--;
            ln--;
          }
        }
      }

      return clone;
    },
    reduce: Array.prototype.reduce ? function(array, reduceFn, initialValue) {
      if(arguments.length === 3) {
        return Array.prototype.reduce.call(array, reduceFn, initialValue);
      }
      return Array.prototype.reduce.call(array, reduceFn);
    } : function(array, reduceFn, initialValue) {
      array = Object(array);

      var index = 0;
      var length = array.length >>> 0;
      var reduced = initialalue;

      if(arguments.length < 3) {
        while(true) {
          if(index in array) {
            reduced = array[index++];
            break;
          }
          if(++index >= length) {
            throw new TypeError('Reduce of empty array with no initial value');
          }
        }
      }

      for(; index < length; ++index) {
        if(index in array) {
          reduced = reduceFn(reduced, array[index], index, array);
        }
      }

      return reduced;
    },
    slice: [1, 2].slice(1, undefined).length ? function(array, begin, end) {
      return slice.call(array, begin, end);
    } : function(array, begin, end) {
      if(typeof begin === 'undefined') {
        return slice.call(array);
      }
      if(typeof end === 'undefined') {
        return slice.call(array, begin);
      }
      return slice.call(array, begin, end);
    },
    sort: function(array, sortFn) {
      return stableSort(array, sortFn || utilArray.lexicalCompare);
    },
    flatten: function(array) {
      var worker = [];

      function rFlatten(a) {
        for(var i = 0, ln = a.length; i < ln; i++) {
          var v = a[i];

          if(util.isArray(v)) {
            rFlatten(v);
          }
          else {
            worker.push(v);
          }
        }

        return worker;
      }

      return rFlatten(array);
    },
    min: function(array, comparisonFn) {
      var min = array[0];

      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        if(comparisonFn) {
          if(comparisonFn(min, item) === 1) {
            min = item;
          }
        }
        else {
          if(item < min) {
            min = item;
          }
        }
      }

      return min;
    },
    max: function(array, comparisonFn) {
      var max = array[0];

      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        if(comparisonFn) {
          if(comparisonFn(max, item) === -1) {
            max = item;
          }
        }
        else {
          if(item > max) {
            max = item;
          }
        }
      }

      return max;
    },
    mean: function(array) {
      return array.length > 0 ? utilArray.sum(array) / array.length : undefined;
    },
    sum: function(array) {
      var sum = 0;
      for(var i = 0, ln = array.length; i < ln; i++) {
        var item = array[i];

        sum += item;
      }

      return sum;
    },
    toMap: function(strings, getKey, scope) {
      if(!strings) {
        return null;
      }

      var map = {};
      var i = strings.length;

      if(typeof strings === 'string') {
        map[strings] = 1;
      }
      else if(!getKey) {
        while(i--) {
          map[strings[i]] = i + 1;
        }
      }
      else if(typeof getKey === 'string') {
        while(i--) {
          map[strings[i][getKey]] = i + 1;
        }
      }
      else {
        while(i--) {
          map[getKey.call(scope, strings[i])] = i + 1;
        }
      }

      return map;
    },
    toValueMap: function(array, getKey, scope, arrayify) {
      var map = {};
      var i = array.length;
      var entry;
      var fn;
      var value;

      if(!getKey) {
        while(i--) {
          value = array[i];
          map[value] = value;
        }
      }
      else {
        if(!(fn = typeof getKey !== 'string')) {
          arrayify = scope;
        }

        var alwaysArray = arrayify === 1;
        var autoArray = arrayify === 2;

        while(i--) {
          value = array[i];
          var key = fn ? getKey.call(scope, value) : value[getKey];

          if(alwaysArray) {
            if(key in map) {
              map[key].push(value);
            }
            else {
              map[key] = [value];
            }
          }
          else if(autoArray && key in map) {
            if(entry = map[key] instanceof Array) {
              entry.push(value);
            }
            else {
              map[key] = [entry, value];
            }
          }
          else {
            map[key] = value;
          }
        }
      }

      return map;
    },
    erase: erase,
    insert: function(array, index, items) {
      return replace(array, index, 0, items);
    },
    move: function(array, fromIdx, toIdx) {
      if(toIdx === fromIdx) {
        return;
      }

      var item = array[fromIdx];

      for(var incr = toIdx > fromIdx ? 1 : -1, i = fromIdx; i != toIdx; i += incr) {
        array[i] = array[i + incr];
      }
      array[toIdx] = item;
    },
    replace: replace,
    splice: splice,
    push: function(target) {
      var args = arguments;

      if(target === undefined) {
        target = [];
      }
      else if(!util.isArray(target)) {
        target = [target];
      }

      for(var len = args.length, i = 1; i < len; i++) {
        var newItem = args[i];
        Array.prototype.push[util.isIterable(newItem) ? 'apply' : 'call'](target, newItem);
      }

      return target;
    },
    numericSortFn: function(a, b) {
      return a - b;
    }
  };

  util.each = utilArray.each;
  utilArray.union = utilArray.merge;
  util.min = utilArray.min;
  util.max = utilArray.max;
  util.sum = utilArray.sum;
  util.mean = utilArray.mean;
  util.flatten = utilArray.flatten;
  util.clean = utilArray.clean;
  util.unique = utilArray.unique;
  util.pluck = utilArray.pluck;
  util.toArray = function() {
    return utilArray.toArray.apply(utilArray, arguments);
  };

  return utilArray;
}();


util.String = function() {
  var trimRegex = /^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g;
  var escapeRe = /('|\\)/g;
  var escapeRegexRe = /([-.*+?\^${}()|\[\]\/\\])/g;
  var basicTrimRe = /^\s+|\s+$/g;
  var whitespaceRe = /\s+/;
  var varReplace = /(^[^a-z]*|[^\w])/gi;
  var charToEntity;
  var entityToChar;
  var charToEntityRegex;
  var entityToCharRegex;
  var htmlEncodeReplaceFn = function(match, capture) {
    return charToEntity[capture];
  };
  var htmlDecodeReplaceFn = function(match, capture) {
    return capture in entityToChar ? entityToChar[capture] : String.fromCharCode(parseInt(capture.substr(2), 10));
  };
  var utilString;

  return utilString = {
    htmlEncode: function(value) {
      return !value ? value : String(value).replace(charToEntityRegex, htmlEncodeReplaceFn);
    },
    htmlDecode: function(value) {
      return !value ? value : String(value).replace(entityToCharRegex, htmlDecodeReplaceFn);
    },
    hasHtmlCharacters: function(s) {
      return charToEntityRegex.test(s);
    },
    addCharacterEntities: function(newEntities) {
      var charKeys = [];
      var entityKeys = [];
      for(var key in newEntities) {
        var echar = newEntities[key];
        entityToChar[key] = echar;
        charToEntity[echar] = key;
        charKeys.push(echar);
        entityKeys.push(key);
      }
      charToEntityRegex = new RegExp('(' + charKeys.join('|') + ')', 'g');
      entityToCharRegex = new RegExp('(' + entityKeys.join('|') + '|&#[0-9]{1,5};)', 'g');
    },
    resetCharacterEntities: function() {
      charToEntity = {};
      entityToChar = {};
      this.addCharacterEntities({
        '&amp;': '&',
        '&gt;': '>',
        '&lt;': '<',
        '&quot;': '"',
        '&#39;': '\''
      });
    },
  };
}();

util.String.resetCharacterEntities();
util.htmlEncode = util.String.htmlEncode;
util.htmlDecode = util.String.htmlDecode;



export default util;
